import { GENERATE_CLIENT_TIMESHEET_HOURS, GENERATE_CLIENT_TIMESHEET_HOURS_ERROR, GET_CLIENT_PROJECT_LIST, GET_CLIENT_PROJECT_LIST_ERROR, GET_CLIENT_TIMESHEET_BULK_LIST, GET_CLIENT_TIMESHEET_BULK_LIST_ERROR, GET_CLIENT_TIMESHEET_HOURS, GET_CLIENT_TIMESHEET_HOURS_ERROR, GET_CLIENT_TIMESHEET_ID, GET_CLIENT_TIMESHEET_ID_ERROR, GET_CLIENT_TIMESHEET_LIST, GET_CLIENT_TIMESHEET_LIST_ERROR, GET_CLIENT_TIMESHEET_STATUS_LIST, GET_CLIENT_TIMESHEET_STATUS_LIST_ERROR, GET_CLIENT_TIMESHEET_WORKER_RATES, GET_CLIENT_TIMESHEET_WORKER_RATES_ERROR, RESET_CLIENT_TIMESHEET_DETAILS, RESET_CLIENT_TIMESHEET_HOUR_DETAILS, SAVE_CLIENT_TIMESHEET, SAVE_CLIENT_TIMESHEET_ERROR } from "../../actions/types";

const initialState = {
    timesheetClientList: [],
    timesheetClientStatusList: [],
    timesheetClientActionList: [],

    timesheetDetail: {},
    timesheetScheduleList: [],
    timesheetWorkerRates: {},
    timesheetHourDetail: {},
    clientProjectListForTimesheet: [],
}

export const clientTimesheet = (state = initialState, action) => {
    switch (action.type) {

        case GET_CLIENT_TIMESHEET_STATUS_LIST:
            return {
                ...state,
                timesheetClientStatusList: action.payload.data,
            };
        case GET_CLIENT_TIMESHEET_STATUS_LIST_ERROR:
            return {
                ...state,
                timesheetClientStatusList: [],
            };
        case GET_CLIENT_TIMESHEET_LIST:
            return {
                ...state,
                timesheetClientList: action.payload.data,
            };
        case GET_CLIENT_TIMESHEET_LIST_ERROR:
            return {
                ...state,
                timesheetClientList: [],
            };
        case GET_CLIENT_TIMESHEET_BULK_LIST:
            return {
                ...state,
                timesheetClientActionList: action.payload.data,
            }
        case GET_CLIENT_TIMESHEET_BULK_LIST_ERROR:
            return {
                ...state,
                timesheetClientActionList: [],
            }
        case RESET_CLIENT_TIMESHEET_DETAILS:
            return {
                ...state,
                timesheetDetail: {},
                timesheetScheduleList: [],
                timesheetClientActionList: [],
            }

        case SAVE_CLIENT_TIMESHEET:
            return {
                ...state,
                timesheetDetail: action.payload.data,
            }
        // case SAVE_CLIENT_TIMESHEET_ERROR:
        //     return {
        //         ...state,
        //         timesheetDetail: {}
        //     }
        case GET_CLIENT_TIMESHEET_ID:
            return {
                ...state,
                timesheetDetail: action.payload.data,
            };
        case GET_CLIENT_TIMESHEET_ID_ERROR:
            return {
                ...state,
                timesheetDetail: {},
            };
        case GENERATE_CLIENT_TIMESHEET_HOURS:
            return {
                ...state,
                timesheetScheduleList: action.payload.data,
            }
        case GENERATE_CLIENT_TIMESHEET_HOURS_ERROR: 
            return {
                ...state,
                timesheetScheduleList: [],
            }
        case GET_CLIENT_TIMESHEET_WORKER_RATES:
            return {
                ...state,
                timesheetWorkerRates: action.payload.data,
            }
        case GET_CLIENT_TIMESHEET_WORKER_RATES_ERROR:
            return {
                ...state,
                timesheetWorkerRates: {},
            }
        
        case GET_CLIENT_TIMESHEET_HOURS: 
            return {
                ...state,
                timesheetHourDetail: action.payload.data,
            }
        case GET_CLIENT_TIMESHEET_HOURS_ERROR: 
            return {
                ...state,
                timesheetHourDetail: {},
            }        
        case RESET_CLIENT_TIMESHEET_HOUR_DETAILS:
            return {
                ...state,
                timesheetHourDetail: {},
            }

        case GET_CLIENT_PROJECT_LIST: {
            return {
                ...state,
                clientProjectListForTimesheet: action.payload.data,
            }
        }
        case GET_CLIENT_PROJECT_LIST_ERROR: {
            return {
                ...state,
                clientProjectListForTimesheet: [],
            }
        }

        default:
            return state;
    }
}